import React from 'react';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';

export const FileUpload = ({ accept, onFileChange, fieldName, disabled }) => {
  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'done') {
      onFileChange(file, fieldName);
    } else if (status === 'removed') {
      onFileChange(null, fieldName);
    }
  };

  if (disabled) {
    return (
      <input
        className="form__input"
        type="text"
        readOnly
        id="add-event-image"
        accept="image/*"
        placeholder="Upgrade to a Featured Event"
        name="image"
      ></input>
    );
  } else {
    return (
      <Dropzone
        onChangeStatus={handleChangeStatus}
        accept={accept}
        disabled={disabled}
        inputContent={
          <div>
            <h3 className="u--margin-0">Drag & Drop Files Here</h3>
            <span>or</span>
            <p>Choose Files</p>
          </div>
        }
        classNames={{
          input: 'u--display-none'
        }}
        styles={{
          inputLabel: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '30px',
            textAlign: 'center'
          },
          input: {
            width: 'auto',
            textAlign: 'center'
          },
          preview: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px'
          },
          previewImage: {
            maxHeight: '100px',
            objectFit: 'cover'
          }
        }}
        inputWithFilesContent={null}
      />
    );
  }
};
